import { webApiWithResponse } from "../../../../core/http/httpThunks";
import { GuaranteeData } from "../types";

export const createGuaranteeApi = (userId: string, guarantee: GuaranteeData) =>
  webApiWithResponse<string>({
    method: "PUT",
    url: "clearing/newpayment",
    params: {
      userId,
    },
    data: guarantee,
  });

export default createGuaranteeApi;
